<script>
  import { ICONS } from "../services/utils";
  // import Icon from "./Icon.svelte";
  import widgetStore from 'store/widget';
  
  const { logo } = $widgetStore;

</script>

<div class="container">
  <div class="header">
    <div class="header-overlay"></div>
    <div class="header-logo">
      {#if logo}
        <img src={logo} width="60px" alt="logo" />
      {:else}
        <img src={ICONS.logo} width="60px" alt="logo" />
      {/if}
    </div>
  </div>
</div>
<!-- {/if} -->

<style lang="scss">
  .header-logo {
    background-color: #fff;
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
    /* border: solid 5px lightblue; */
    position: relative;
    border-radius: 50%;
    width: 60px;
    height: 60px;
    overflow: hidden;
    &::before {
      content: "";
      position: absolute;
      inset: 0;
      border-radius: 50px;
      padding: 7px; /* control the border thickness */
      background: linear-gradient(45deg, color-mix(in srgb, var(--primary-bg-color) 50%, white), var(--primary-bg-color));
      -webkit-mask: 
          linear-gradient(#fff 0 0) content-box, 
          linear-gradient(#fff 0 0);
      -webkit-mask-composite: xor;
              mask-composite: exclude;
      pointer-events: none;
    }
  }

  .header {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 8px;
    background: var(--primary-bg-color);
    font-family: 'Recoleta';
    font-weight: 500;
    font-size: 14px;
    position: relative;
    width: 75px;
    height: 75px;
    top: 25px;
    left: 25px;
    border-bottom-left-radius: 12px;
  }

  .header-overlay {
    cursor: pointer;
    position: absolute;
    left: 0;
    bottom: 0;
    border-radius: 50%;
    width: 135px;
    height: 135px;
    display: flex;
    justify-content: center;
    align-items: center;
    background: var(--primary-bg-color);
  }
</style>
